<div
  [class]="backgroundColour ? backgroundColour : ''"
  [ngClass]="{
    'is-dual-box--overlay': layoutSelector === 'dual-box-overlay',
    'grid-block__full-width-bleed': allowBackgroundFullWidthBleed,
    'grid-block__with-background': isParentBackgroundColour,
    'grid-block__with-box-borders': hasBoxBorders,
    'grid-block__flip-cards': isFlipCards
  }"
  class="grid-block lg-container"
  lgContainer
>
  @if (
    (contentLayout === "full" && allowBackgroundFullWidthBleed) ||
    (contentLayout === "narrow" && allowBackgroundFullWidthBleed)
  ) {
    <div [class]="['background-panel', backgroundColour]"></div>
  }
  <div
    [ngClass]="{
      'column-content-area':
        contentLayout && contentLayout !== 'full' && contentLayout !== 'narrow',
      'grid-block__container-spacing': followUpButtons
    }"
    class="grid-block__container"
    lgContainer
  >
    @if (headingComponent) {
      <div lgRow>
        <div [lgCol]="12" [lgColMd]="pageType === 'ArticlePage' ? 12 : 8">
          <dotcom-frontend-loader [componentData]="headingComponent" />
        </div>
      </div>
    }

    <div
      [class]="layoutSelector || ''"
      [ngClass]="{
        'grid-block__dual-box': isDualBox
      }"
      lgRow
    >
      @switch (layoutSelector) {
        @case ("flip-card") {
          @for (boxBlock of boxBlocks; let i = $index; track i) {
            <div [lgColLg]="4" [lgColMd]="6" [lgColSm]="12">
              <ng-container
                [ngTemplateOutletContext]="{ boxBlock: boxBlock }"
                [ngTemplateOutlet]="boxBlockList"
              />
            </div>
          }
        }
        @case ("third-2") {
          <div [lgColLg]="8" [lgColSm]="12">
            <div class="lg-row">
              @for (boxBlock of boxBlocks; let i = $index; track i) {
                <div [lgColMd]="6" [lgColSm]="12">
                  <ng-container
                    [ngTemplateOutletContext]="{ boxBlock: boxBlock }"
                    [ngTemplateOutlet]="boxBlockList"
                  />
                </div>
              }
            </div>
          </div>
        }
        @case ("alternating-grid") {
          @for (
            boxBlock of boxBlocks;
            let i = $index;
            let isEven = $even;
            track i
          ) {
            <div [lgColMd]="alternateRows(i, isEven)" [lgColSm]="12">
              <ng-container
                [ngTemplateOutletContext]="{ boxBlock: boxBlock }"
                [ngTemplateOutlet]="boxBlockList"
              />
            </div>
          }
        }
        @case ("slider" ) {
          @if (boxBlocks) {
            <div class="slider-wrapper">
              <div (scroll)="onScroll()" class="slider-main" [ngClass]="{'slider-main--2x2': data && data['layout'] === 'slider-2x2'}" #sliderMain>
                @for (boxBlock of boxBlocks; let i = $index; track i) {
                  <div [lgColLg]="4" [lgColMd]="6" [lgColSm]="12" class="item">
                    <ng-container
                      [ngTemplateOutletContext]="{ boxBlock: boxBlock }"
                      [ngTemplateOutlet]="boxBlockList"
                    />
                  </div>
                }
              </div>
              <div class="slider-shadow-left"></div>
              <div class="slider-shadow-right"></div>
            </div>

            <div class="slider-control">
              <button
                (click)="scroll('left')"
                aria-label="slide left"
                class="lg-btn slider-control--button"
              >
                <lg-icon name="chevron-left" />
              </button>
              <div class="slider-control--bar">
                <span
                  [ngStyle]="{
                    width: sliderBarWidth,
                    left: sliderBarPosition
                  }"
                  class="slider-control--bar-position"
                ></span>
              </div>
              <button
                (click)="scroll('right')"
                aria-label="slide right"
                class="lg-btn slider-control--button"
              >
                <lg-icon name="chevron-right" />
              </button>
            </div>
          }
        }
        @default {
          @for (boxBlock of boxBlocks; let i = $index; track i) {
            <div
              [class]="{
                'is-dual-box': isDualBox,
                'is-dual-box--overlay': isDualBoxOverlay
              }"
              [lgColLg]="gridLayout"
              [lgColMd]="twoOnTablet ? 6 : gridLayout"
              [lgColSm]="12"
            >
              <ng-container
                [ngTemplateOutletContext]="{ boxBlock: boxBlock }"
                [ngTemplateOutlet]="boxBlockList"
              />
            </div>
          }
        }
      }
    </div>

    @if (followUpButtons) {
      <div lgRow>
        <div [lgCol]="12">
          @for (button of followUpButtons; let i = $index; track i) {
            <dotcom-frontend-loader
              [componentData]="button"
              cssClass="followup-cta-button"
            />
          }
        </div>
      </div>
    }
  </div>
</div>

<ng-template #boxBlockList let-boxBlock="boxBlock">
  <dotcom-frontend-loader
    [componentData]="boxBlock"
    [contentLayout]="contentLayout"
    [isParentBackgroundColourSet]="isParentBackgroundColour"
    [parentColour]="data && data['backgroundColour']"
    [parentSpacing]="
      followUpButtons && !isParentBackgroundColour ? 'standard' : 'half'
    "
    [parent]="isParentBackgroundColour ? 'gridWithBackground' : 'grid'"
    [parentBlock] = "'GridBoxBlock'"
  />
</ng-template>
